(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-product-types"] && !Shopify.designMode) return;
  try {
    (() => {
  const queries = new Map();
  const collapsed = new Map();
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/ß/g, 'ss');
  const updateGroups = picker => {
    picker.querySelectorAll('[data-type-group]').forEach(input => {
      const leaves = [...input.closest('[data-type-branch]').querySelectorAll('[data-type-option] input')];
      const selected = leaves.filter(leaf => leaf.checked).length;
      input.checked = leaves.length > 0 && selected === leaves.length;
      input.indeterminate = selected > 0 && selected < leaves.length;
      input.setAttribute('aria-checked', input.indeterminate ? 'mixed' : String(input.checked));
    });
  };
  const filterOptions = (picker, query) => {
    const terms = normalize(query).trim().split(/\s+/).filter(Boolean);
    let visible = 0;
    picker.querySelectorAll('[data-type-option]').forEach(option => {
      if (option.hasAttribute('data-type-unlisted')) {
        option.hidden = true;
        return;
      }
      option.hidden = !terms.every(term => normalize(option.dataset.typeSearchText || option.dataset.typeLabel).includes(term));
      if (!option.hidden) visible += 1;
    });
    [...picker.querySelectorAll('[data-type-branch]')].reverse().forEach(branch => {
      branch.hidden = ![...branch.querySelectorAll('[data-type-option]')].some(option => !option.hidden);
      const children = [...branch.children].find(child => child.hasAttribute('data-type-children'));
      const toggle = branch.querySelector('[data-type-toggle]');
      if (children && toggle) {
        const open = terms.length > 0 || collapsed.get(branch.dataset.typeBranch) === false;
        children.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
      }
    });
    picker.querySelector('[data-type-empty]').hidden = visible > 0;
  };
  const buildHierarchy = picker => {
    const data = picker.querySelector('[data-type-menu]');
    if (!data) return;
    let menu;
    try { menu = JSON.parse(data.textContent); } catch { return; }
    const list = picker.querySelector('[data-type-list]');
    const options = new Map([...list.children].map(option => [option.querySelector('input').value, option]));
    const used = new Set();
    let branchIndex = 0;
    const find = nodes => {
      for (const node of nodes) {
        if (node.handle === picker.dataset.typeContext) return node;
        const nested = find(node.children || []);
        if (nested) return nested;
      }
    };
    const leaf = (value, ancestors) => {
      if (!options.has(value) || used.has(value)) return null;
      used.add(value);
      const option = options.get(value);
      option.dataset.typeSearchText = ancestors.concat(option.dataset.typeLabel).join(' ');
      return option;
    };
    const build = (node, ancestors = []) => {
      const path = ancestors.concat(node.label);
      const children = (node.children || []).map(child => build(child, path)).filter(Boolean);
      const values = node.values.filter(value => value !== '*' && value !== '-');
      const ownValues = values.map(value => leaf(value, path)).filter(Boolean);
      const categoryAliases = { 'GP Utility Pouches': 'Utility Pouches', 'Zip-On / Back Panels': 'Zip-On & Back Panels' };
      const distinctValues = new Set(ownValues.map(option => {
        const value = option.querySelector('input').value;
        return categoryAliases[value] || value;
      }));
      const nestedItems = children.length ? children.concat(ownValues) : distinctValues.size > 1 ? ownValues : [];
      if (!children.length && !ownValues.length) return null;
      if (!node.children.length && values.length === 1 && ownValues.length === 1) {
        ownValues[0].querySelector('.mgp-type-picker__label').textContent = node.label;
        return ownValues[0];
      }
      const item = document.createElement('li');
      item.className = 'mgp-type-picker__branch' + (children.length ? '' : ' mgp-type-picker__terminal');
      item.dataset.typeBranch = picker.dataset.typeContext + '|' + picker.dataset.typePicker + '|' + node.handle;
      const row = document.createElement('div');
      row.className = 'mgp-type-picker__branch-row';
      const label = document.createElement('label');
      label.className = 'mgp-type-picker__row mgp-type-picker__group-row';
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.dataset.typeGroup = node.handle;
      const text = document.createElement('span');
      text.className = 'mgp-type-picker__label';
      text.textContent = node.label;
      label.append(input, text);
      row.append(label);
      item.append(row);
      if (nestedItems.length) {
        const nestedList = document.createElement('ul');
        nestedList.className = 'mgp-type-picker__children';
        nestedList.dataset.typeChildren = '';
        nestedList.hidden = true;
        nestedList.id = picker.dataset.typePicker + '-type-branch-' + (++branchIndex);
        nestedList.setAttribute('role', 'list');
        nestedList.append(...nestedItems);
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'mgp-type-picker__toggle';
        toggle.dataset.typeToggle = '';
        toggle.setAttribute('aria-label', node.label);
        toggle.setAttribute('aria-controls', nestedList.id);
        toggle.setAttribute('aria-expanded', 'false');
        toggle.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="m3 4.5 3 3 3-3"/></svg>';
        input.setAttribute('aria-controls', nestedList.id);
        row.append(toggle);
        item.append(nestedList);
      }
      if (ownValues.length && !nestedItems.length) {
        const nativeValues = document.createElement('ul');
        nativeValues.hidden = true;
        nativeValues.dataset.typeInternal = '';
        nativeValues.append(...ownValues);
        item.append(nativeValues);
      }
      return item;
    };
    const current = find(menu);
    const roots = current ? current.children : menu;
    const tree = roots.map(node => build(node)).filter(Boolean);
    if (current) {
      current.values.filter(value => value !== '*' && value !== '-').forEach(value => {
        const option = leaf(value, [current.label]);
        if (option) tree.push(option);
      });
    }
    const unlisted = document.createElement('ul');
    unlisted.hidden = true;
    unlisted.dataset.typeInternal = '';
    for (const value of options.keys()) {
      const option = leaf(value, []);
      if (option) {
        option.dataset.typeUnlisted = '';
        unlisted.append(option);
      }
    }
    list.replaceChildren(...tree);
    if (unlisted.children.length) picker.append(unlisted);
    picker.classList.add('mgp-type-picker--hierarchical');
    updateGroups(picker);
  };
  const prepare = () => {
    const collator = new Intl.Collator(document.documentElement.lang || 'en', { sensitivity: 'base', numeric: true });
    document.querySelectorAll('[data-type-picker]:not([data-type-ready])').forEach(picker => {
      picker.dataset.typeReady = 'true';
      const list = picker.querySelector('[data-type-list]');
      [...list.children].sort((a, b) => collator.compare(a.dataset.typeLabel, b.dataset.typeLabel)).forEach(option => list.append(option));
      buildHierarchy(picker);
      const input = picker.querySelector('[data-type-search]');
      const query = queries.get(picker.dataset.typePicker) || '';
      if (input) input.value = query;
      filterOptions(picker, query);
    });
  };
  prepare();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  new MutationObserver(prepare).observe(document.querySelector('[data-section-type="collection"]') || document.body, { childList: true, subtree: true });
  document.addEventListener('change', event => {
    const group = event.target.closest('[data-type-group]');
    if (group) {
      event.stopImmediatePropagation();
      const leaves = [...group.closest('[data-type-branch]').querySelectorAll('[data-type-option] input')];
      const changed = leaves.find(input => input.checked !== group.checked);
      leaves.forEach(input => { input.checked = group.checked; });
      updateGroups(group.closest('[data-type-picker]'));
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (event.target.matches('[data-type-option] input')) {
      updateGroups(event.target.closest('[data-type-picker]'));
    }
  }, true);
  document.addEventListener('input', event => {
    const input = event.target.closest('[data-type-search]');
    if (!input) return;
    const picker = input.closest('[data-type-picker]');
    queries.set(picker.dataset.typePicker, input.value);
    filterOptions(picker, input.value);
    picker.querySelector('[data-type-list]').scrollTop = 0;
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-type-toggle]');
    if (!toggle) return;
    const branch = toggle.closest('[data-type-branch]');
    collapsed.set(branch.dataset.typeBranch, toggle.getAttribute('aria-expanded') === 'true');
    const picker = branch.closest('[data-type-picker]');
    filterOptions(picker, picker.querySelector('[data-type-search]')?.value || '');
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-type-search]')) event.preventDefault();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mgp-malice-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mgp-malice-addon')) {
    customElements.define('mgp-malice-addon', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = this.closest('form');
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.config = JSON.parse(this.querySelector('.mgp-malice__config').textContent);
        this.status = this.querySelector('.mgp-malice__status');
        this.summary = this.querySelector('.mgp-malice__summary');
        this.expressFields = this.querySelector('.mgp-malice__express-fields');
        this.blockedPayments = new Set();
        const indices = [...this.form.querySelectorAll('[name^="shopify-additional-items["]')].map(input => Number(input.name.match(/^shopify-additional-items\[(\d+)\]/)?.[1]) || 0);
        this.expressIndex = Math.max(0, ...indices) + 1;
        this.fresh = false;
        this.busy = false;
        this.variants = this.config.variants;
        const options = { signal: this.controller.signal };
        this.form.addEventListener('variant:changed', () => { this.checkbox.checked = false; this.render(); this.refresh(); }, options);
        this.form.addEventListener('change', () => this.render(), options);
        this.form.addEventListener('input', event => { if (event.target.name === 'quantity') this.render(); }, options);
        this.checkbox.addEventListener('change', () => { if (this.checkbox.checked) this.refresh(); }, options);
        this.form.addEventListener('click', event => {
          if (event.target.closest('.shopify-payment-button')) return;
          const button = event.target.closest('button[type="submit"]');
          if (button && (this.checkbox.checked || this.busy)) this.intercept(event, button);
        }, { ...options, capture: true });
        this.form.addEventListener('submit', event => {
          if (event.submitter?.closest('.shopify-payment-button')) return;
          if (this.checkbox.checked || this.busy) this.intercept(event, event.submitter || this.form.querySelector('button[type="submit"]'));
        }, { ...options, capture: true });
        window.addEventListener('focus', () => this.refresh(), options);
        document.addEventListener('cart:refresh', () => { if (!this.busy) this.refresh(); }, options);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.refresh(); }, options);
        this.render();
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.expressFields?.replaceChildren();
        this.blockedPayments?.forEach(payment => { payment.inert = false; payment.removeAttribute('data-malice-pending'); });
      }
      selection() {
        const size = this.config.sizes[this.form.querySelector('[name="id"]')?.value];
        return this.variants.find(v => v.option1 === size);
      }
      quantity() { return Math.max(1, Math.floor(Number(this.form.querySelector('[name="quantity"]')?.value) || 1)); }
      packs() { return Math.ceil(Number(this.dataset.clips) * this.quantity() / 2); }
      canAdd(variant = this.selection()) { return Boolean(this.fresh && variant?.available && Number(variant.remaining) >= this.packs()); }
      money(cents) { return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(cents / 100); }
      template(text, values) { return text.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match); }
      syncExpress() {
        this.expressFields.replaceChildren();
        if (this.checkbox.checked && this.canAdd() && !this.busy) {
          for (const [key, value] of Object.entries({ id: this.selection().id, quantity: this.packs() })) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `shopify-additional-items[${this.expressIndex}][${key}]`;
            input.value = String(value);
            this.expressFields.append(input);
          }
        }
        const blocked = this.busy || (this.checkbox.checked && !this.canAdd());
        for (const payment of this.form.querySelectorAll('.shopify-payment-button')) {
          if (blocked && !payment.inert) {
            payment.inert = true;
            payment.setAttribute('data-malice-pending', '');
            this.blockedPayments.add(payment);
          } else if (!blocked && this.blockedPayments.has(payment)) {
            payment.inert = false;
            payment.removeAttribute('data-malice-pending');
            this.blockedPayments.delete(payment);
          }
        }
      }
      render() {
        const variant = this.selection();
        this.hidden = !variant;
        if (!variant) { this.checkbox.checked = false; this.syncExpress(); return; }
        const available = this.canAdd(variant);
        this.checkbox.disabled = !available || this.busy;
        this.dataset.unavailable = String(!available);
        if (!available && this.fresh) this.checkbox.checked = false;
        const packs = this.packs();
        const values = { packs, size: variant.option1 === 'Long' ? this.dataset.long : this.dataset.short, price: this.money(variant.price * packs) };
        this.summary.textContent = this.template(this.dataset.packLabel, values);
        this.syncExpress();
        if (!this.busy) this.status.textContent = !this.fresh ? this.dataset.checking : (!variant.available ? this.dataset.stock : (!available ? this.dataset.insufficient : ''));
      }
      async refresh(force = false) {
        if (this.refreshing) {
          if (!force) return this.refreshing;
          await this.refreshing;
        }
        this.fresh = false;
        this.render();
        this.refreshing = (async () => {
          try {
            const response = await fetch(`${this.dataset.productUrl}?section_id=mgp-malice-stock&_=${Date.now()}`, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
            if (!response.ok) throw new Error('Product availability unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = JSON.parse(html.querySelector('[data-malice-stock]')?.textContent || 'null');
            if (!data || String(data.productId) !== this.dataset.productId || !Array.isArray(data.variants) || !data.variants.length) throw new Error('Invalid availability data');
            this.variants = data.variants;
            this.fresh = true;
            this.render();
            return this.selection();
          } catch (error) {
            this.fresh = false;
            this.checkbox.checked = false;
            this.render();
            this.status.textContent = this.dataset.error;
            return null;
          } finally { this.refreshing = null; }
        })();
        return this.refreshing;
      }
      async intercept(event, button) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || !this.form.reportValidity() || !button || button.disabled) return;
        this.busy = true;
        const initialId = this.form.querySelector('[name="id"]').value;
        button.disabled = true;
        this.checkbox.disabled = true;
        this.status.textContent = this.dataset.checking;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        let success = false;
        try {
          const variant = await this.refresh(true);
          if (!this.canAdd(variant) || this.form.querySelector('[name="id"]').value !== initialId || !this.checkbox.checked) throw new Error(variant?.available ? this.dataset.insufficient : this.dataset.stock);
          const formData = new FormData(this.form);
          const main = { id: initialId, quantity: this.quantity(), properties: {} };
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && typeof value === 'string') main.properties[match[1]] = value;
          }
          if (formData.get('selling_plan')) main.selling_plan = formData.get('selling_plan');
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [main, { id: variant.id, quantity: this.packs() }] }) });
          const result = await response.json();
          if (!response.ok) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          success = true;
          variant.remaining = Math.max(0, variant.remaining - this.packs());
          button.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button, variant: null, quantity: main.quantity, productAdded: true } }));
          if (window.theme?.pageType === 'cart' || window.theme?.cartType === 'page') window.location.href = window.routes?.cartUrl || `${root}cart`;
          if (window.theme?.cartType === 'drawer') document.dispatchEvent(new CustomEvent('modal:close'));
          this.status.textContent = this.dataset.added;
        } catch (error) {
          this.status.textContent = [this.dataset.stock, this.dataset.insufficient].includes(error.message) ? error.message : this.dataset.error;
        } finally {
          this.busy = false;
          if (button.isConnected && this.form.querySelector('[name="id"]').value === initialId) button.disabled = false;
          this.checkbox.disabled = !this.canAdd();
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          if (success) this.checkbox.checked = false;
          this.syncExpress();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mgp-size-chart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-size-chart-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.sizeChartOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-size-chart-close]');
    if (closer) {
      closer.closest('dialog').close();
      return;
    }
    if (event.target.matches('dialog.mgp-size-chart-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-selector"] && !Shopify.designMode) return;
  try {
    function mgpRestoreRdsoVariant() {
  if (!document.querySelector('[data-mgp-rdso-options]')) return;
  const legacy = {
    '55445150335300': '57560644059460',
    '55445150368068': '57560658542916',
    '55445150400836': '57560662999364',
    '55445150433604': '57560668045636'
  };
  const url = new URL(window.location.href);
  const replacement = legacy[url.searchParams.get('variant')];
  if (!replacement) return;
  url.searchParams.set('variant', replacement);
  window.location.replace(url.href);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mgpRestoreRdsoVariant, { once: true });
} else {
  mgpRestoreRdsoVariant();
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('input[data-option-position]')) return;
  const picker = input.closest('variant-picker');
  const config = picker?.querySelector('[data-mgp-rdso-options]');
  if (!config) return;
  const data = JSON.parse(config.textContent);
  const controls = Array.from(picker.querySelectorAll('input[data-option-position]'));
  const selected = [1, 2, 3].map((position) =>
    controls.find((control) => Number(control.dataset.optionPosition) === position && control.checked)
  );
  const labels = selected.map((control, index) =>
    data.options[index].find((value) => String(value.id) === control?.value)?.label
  );
  const matches = data.variants.filter((variant) =>
    variant.options[0] === labels[0] && variant.options[1] === labels[1]
  );
  if (!matches.length || matches.some((variant) => variant.options[2] === labels[2])) return;
  const replacement = matches.find((variant) => variant.available) || matches[0];
  const value = data.options[2].find((option) => option.label === replacement.options[2]);
  if (!value) return;
  controls.filter((control) => Number(control.dataset.optionPosition) === 3).forEach((control) => {
    control.checked = control.value === String(value.id);
  });
}, true);
  } catch(e) { console.error(e); }
})();

})();
